<div
  class="textarea"
  [ngClass]="{
    'show-response-view': isComponentResponseView(),
    disabled: spinnerConversational(),
  }"
>
  <textarea
    data-fs-element="Open-Search-Textarea-Question"
    #autoGrow
    rows="1"
    class="auto-grow-textarea"
    [formControl]="textControl"
    (input)="onInput()"
    (keydown.enter)="onEnterKey($event)"
    [placeholder]="'OPEN_SEARCH.WRITE_QUESTION' | translate"
    [ngClass]="[!isComponentResponseView() && !showAllResults() ? 'search--full' : 'search-page']"
  ></textarea>
  <div class="input-buttons" id="open-search-button">
    @if (showResponseView()) {
      <button
        data-fs-element="Open-Search-Button-textarea-Search"
        mat-icon-button
        [matTooltip]="
          (spinnerConversational() ? 'OPEN_SEARCH.CANCEL' : 'OPEN_SEARCH.SEARCH_TOOLTIP')
            | translate
        "
        class="search-btn"
        [class.cancel-btn]="spinnerConversational()"
        [disabled]="!spinnerConversational() && isDisabledComponent()"
        (click)="spinnerConversational() ? onCancelSearch() : onSearch()"
      >
        <div
          [class.circle-stop]="spinnerConversational()"
          [class.send-btn]="!spinnerConversational()"
        >
          <mat-icon
            [fontIcon]="spinnerConversational() ? 'stop' : 'send'"
            [class.icon-stop]="spinnerConversational()"
            [class.icon-send]="!spinnerConversational()"
          ></mat-icon>
        </div>
      </button>
      <div
        class="search-panel-container"
        [ngClass]="{
          recent: showRecentSearchPanel(),
          quick: showQuickSearchPanel(),
        }"
      >
        @if (showRecentSearchPanel() || showQuickSearchPanel()) {
          <app-search-panel
            [(searchType)]="searchType"
            [isSmallVersion]="true"
            [(items)]="items"
            [(showAllResults)]="showAllResults"
            [(showSearchPanel)]="showSearchPanel"
            [(isShowAllResults)]="isShowAllResults"
          />
        }
      </div>
    } @else {
      <button
        data-fs-element="Open-Search-Button-textarea-Search"
        mat-icon-button
        [matTooltip]="'OPEN_SEARCH.SEARCH_TOOLTIP' | translate"
        class="search-btn"
        (click)="onSearch()"
      >
        <mat-icon fontIcon="send" class="icon-m"></mat-icon>
      </button>
    }
  </div>
</div>
@if (showResponseView()) {
  <div class="search-type-container">
    <!-- <button
      class="query-mode-trigger"
      data-fs-element="Open-Search-Button-Query-Mode"
      [class.query-mode-trigger--selected]="queryMode() === 'curated-lessons'"
      [matMenuTriggerFor]="queryModesMenu"
      #queryModesMenuTrigger="matMenuTrigger"
      [attr.aria-label]="'OPEN_SEARCH.QUERY_MODES' | translate"
    >
      <span class="query-mode-icon-container" aria-hidden="true">
        @if (queryMode() === 'curated-lessons') {
          <img class="query-mode-icon" src="/images/icons/query-mode-folder-special.svg" alt="" />
        } @else {
          <img class="query-mode-icon" src="/images/icons/query-mode-dashboard.svg" alt="" />
        }
      </span>

      <span class="query-mode-label body-medium" [class.bold]="queryMode() === 'curated-lessons'">
        {{
          (queryMode() === 'curated-lessons'
            ? 'OPEN_SEARCH.CURATED_LESSONS_SELECTED'
            : 'OPEN_SEARCH.QUERY_MODES'
          ) | translate
        }}
      </span>

      <mat-divider vertical></mat-divider>

      <mat-icon
        class="query-mode-arrow"
        [fontIcon]="queryModesMenuTrigger.menuOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
      ></mat-icon>
    </button> -->
    <div class="icon-button">
      <button
        id="new-search-button"
        data-fs-element="Open-Search-Button-Input-NewChat"
        [disabled]="spinnerConversational()"
        mat-icon-button
        [matTooltip]="'OPEN_SEARCH.NEW_SEARCH' | translate"
        (click)="onNewSearchClick()"
      >
        <mat-icon fontIcon="edit_square" class="icon-m material-symbols-outlined"></mat-icon>
      </button>
      <mat-divider vertical style="height: 12px"></mat-divider>
      <div style="display: flex; align-items: center" id="shortcuts-button">
        <button
          data-fs-element="Open-Search-Button-textarea-Quick-Search"
          mat-icon-button
          [matTooltip]="'OPEN_SEARCH.QUICK_SEARCH' | translate"
          [disabled]="spinnerConversational()"
          (click)="openQuickSearch()"
          [ngClass]="{ active: showQuickSearchPanel() }"
        >
          <mat-icon fontIcon="auto_awesome" class="icon-m"></mat-icon>
        </button>
        <mat-divider vertical style="height: 12px"></mat-divider>
        <button
          data-fs-element="Open-Search-Button-textarea-Recent-Search"
          mat-icon-button
          [matTooltip]="'OPEN_SEARCH.RECENT_SEARCH' | translate"
          (click)="openRecentSearch()"
          [disabled]="spinnerConversational()"
          [ngClass]="{ active: showRecentSearchPanel() }"
        >
          <mat-icon fontIcon="bookmark" class="icon-s"></mat-icon>
        </button>
      </div>
    </div>
  </div>
  <mat-menu #queryModesMenu="matMenu" class="query-mode-menu">
    <button
      mat-menu-item
      class="query-mode-menu-item query-mode-menu-item--curated label-medium-semibold"
      data-fs-element="Open-Search-Button-Query-Mode-Curated-Lessons"
      (click)="queryMode.set('curated-lessons')"
    >
      <span class="query-mode-menu-icon-container" aria-hidden="true">
        <img
          class="query-mode-menu-icon"
          src="/images/icons/query-mode-folder-special.svg"
          alt=""
        />
      </span>
      <span>{{ 'OPEN_SEARCH.CURATED_LESSONS_OPTION' | translate }}</span>
    </button>
    <button
      mat-menu-item
      class="query-mode-menu-item query-mode-menu-item--default"
      data-fs-element="Open-Search-Button-Query-Mode-Default"
      (click)="queryMode.set('default')"
    >
      <span class="query-mode-menu-icon-container" aria-hidden="true">
        <img class="query-mode-menu-icon" src="/images/icons/query-mode-dashboard.svg" alt="" />
      </span>
      <span>{{ 'OPEN_SEARCH.QUERY_MODES' | translate }}</span>
    </button>
  </mat-menu>
}
